import Vue from "vue";
import App from "./App.vue";
import router from "./router";
// import store from './store';
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import {
  applyPolyfills,
  defineCustomElements,
} from "@aws-amplify/ui-components/loader";

import { Amplify } from "aws-amplify";
import awsconfig from "./services/aws-exports";
import axios from "axios";
import VueAxios from "vue-axios";
import setupAxios from "@/axiosConfig";

import { useAuth } from "@/store/auth";
import pinia from "@/store";

Amplify.configure(awsconfig);

applyPolyfills().then(() => {
  defineCustomElements(window);
});
Vue.config.ignoredElements = [/amplify-\w*/];

// Register BootstrapVue in your app entry point
Vue.use(VueAxios, axios);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.config.productionTip = false;

const Instance = new Vue({
  name: "Account Center",
  router,
  pinia,
  beforeMount() {
    setupAxios(axios, pinia);
    useAuth().getCurrentUserInfo();
  },
  render: (h) => h(App),
}).$mount("#app");
export default Instance;
export const { $Amplify, $http } = Instance;
